import { MEASUREMENT_SYSTEM } from "common/measurements";

const defaultData = (settings = {}) => ({
  name: '',
  type: '',
  decimalPlaces: 2,
  discreteHomepageStats: false,
  customDescription: false,
  lines: [],
  legends: [],
  letterings: [],
  glassBeads: [],
  ticks: {},
  measurement: settings?.measurement || MEASUREMENT_SYSTEM.imperial,
  homepageStatistic: 'liquidMarking',
});
export default defaultData;
